import { atom } from 'recoil';
import type { CaseScope } from '~/containers/patient-list/model';

/**
 * What the loaded connector patient was opened as: a case, a selection of its
 * datasets, or null for the whole patient. Published with the patient's
 * manifest by the viewer's open loader, so a reload can open the same scope
 * again and the header can name it.
 */
export const openedScopeState = atom<CaseScope | null>({
    key: 'openedScope',
    default: null,
});
